<script>
    import { selectedGroup } from '../../store';
    import { Spinner } from 'sveltestrap';    
    import http from '../../api/http.js';
    export let computerId;
    let motherboard;

    $: {    
      computerId;
      loadMotherboard()
    }

    async function loadMotherboard(){
        const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/mobo/${computerId}/${$selectedGroup}`);
        if(res.status == 200){
            motherboard = await res.json();
        }
    }
</script>

{#await loadMotherboard()}
    <Spinner color="primary" type="border"></Spinner>
{:then}
<div class="row">
    <div class="col-sm">     
        <div>
            <label for="manufacturer">Manufacturer:</label>
            <span id="manufacturer">{motherboard.manufacturer}</span>
        </div>  
        <div>
            <label for="bios-version">BIOS Version:</label>
            <span id="bios-version">{motherboard.biosVersion}</span>
        </div>  
    </div>
    <div class="col-sm">
        <div>
            <label for="product">Product:</label>
            <span id="product">{motherboard.product}</span>
        </div>  
    </div>
    <div class="col-sm">
        <div>
            <label for="serial">Serial:</label>
            <span id="serial">{motherboard.serial}</span>
        </div> 
    </div>
</div>
{/await}

<style>
    label{
        font-weight: 600;
    }
</style>